<app-kpi-widget
  [title]="'fuelConsumption.widgets.fuelEfficiency' | transloco"
  [icon]="icon"
  [isLoading]="isLoading"
  [totalValue]="value"
  [percentageDifference]="fuelEfficiencyPercentageChange"
  [costDifference]="difference"
  [widgetDisabled]="widgetDisabled"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [isUptrendPositive]="isUptrendPositive"
  [dropdownOptions]="dropdownOptions"
  [dropdownEnabled]="dropdownEnabled"
  [selectedDropdownValue]="selectedUnit"
  [valueFormatter]="formatValue.bind(this)"
  (dropdownChanged)="onDropdownChanged($event)"
  [hasFooter]="false">
</app-kpi-widget>